

















import { addToCartTrack } from 'frontend/utils/analytics';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

@Component({})
export default class PaywallPlan extends Vue {
  @Prop(String) private readonly axId!: string;
  @Prop(String) private priceVendor!: string;
  @Prop(Boolean) private readonly subpack!: boolean;
  @Prop() private readonly checkoutUrl!: RawLocation;

  private handleClick(e: MouseEvent) {
    addToCartTrack();
    this.$nextTick(() => {
      if (this.checkoutUrl && !e.defaultPrevented) {
        this.$router.push(this.checkoutUrl);
      } else {
        this.$emit('plan-clicked');
      }
    });
  }
}
